export default __webpack_public_path__ + "static/media/ratings-form-mobile.314f3fef.PNG";